

const numerical={
    bind: function (el, binding, vnode) {
        el.addEventListener('change', function () {
            
          const value = el.checked ? 1 : 0;
          
          vnode.context[binding.value] = value;

          console.log(el.value);
        });
      }
    }

export default numerical;